import { useBreakpoint } from "./useBreakpoint";

export const useListDetailLayout = (
  currentId: string | undefined,
  options?: { alwaysDrillDown?: boolean },
) => {
  const { isDesktop } = useBreakpoint();
  const alwaysDrillDown = options?.alwaysDrillDown ?? false;
  const useDrillDown = alwaysDrillDown || !isDesktop;

  return {
    isDesktop,
    useDrillDown,
    showList: !useDrillDown || !currentId,
    showDetail: !useDrillDown || !!currentId,
  };
};
